import styled, { css } from 'styled-components'

import { Select, fromMd } from '@syconium/little-miss-figgy'

import {
  scrollShadowEdges,
  scrollShadowSource,
} from '../../../../../../../lib/shared-styles/scrollShadow'

import { cellText, dataCellText, tableCell } from './styles'

export { Table } from './styles'

export const ScrollShadowWrap = styled.div`
  ${scrollShadowEdges({ color: 'rgba(17, 17, 17, 0.12)', width: '24px' })};
`

export const SizeTableWrap = styled.div`
  ${scrollShadowSource};
  border: 1px solid ${o => o.theme.color.stroke.neutral.border.decoration.on.background};
  border-radius: ${o => o.theme.borderRadius.sm};
  overflow-x: auto;
`

export const Row = styled.tr<{ $isHighlighted?: boolean }>`
  background-color: ${o =>
    o.$isHighlighted ? o.theme.color.fill.disabled.subtle : o.theme.color.fill.background};
`

const sizeTableCell = css`
  ${tableCell};
  white-space: nowrap;
  border-bottom: 1px solid ${o => o.theme.color.stroke.neutral.border.decoration.on.background};

  /* The size column is separated from the measurements it describes. */
  &:first-child {
    border-inline-end: 1px solid
      ${o => o.theme.color.stroke.neutral.border.decoration.on.background};
  }

  tr:last-child > & {
    border-bottom: none;
  }
`

export const HeaderCell = styled.th`
  ${sizeTableCell};
  ${cellText};
  background-color: ${o => o.theme.color.fill.subtle};
  color: ${o => o.theme.color.text.primary.on.background};
  font-weight: 700;
`

export const SizeCell = styled.th`
  ${sizeTableCell};
  ${dataCellText};
  font-weight: 700;
`

export const Cell = styled.td`
  ${sizeTableCell};
  ${dataCellText};
`

export const RegionSelect = styled(Select)`
  ${cellText};
  background-color: ${o => o.theme.color.fill.background};
  border: none;
  border-radius: ${o => o.theme.borderRadius.sm};
  flex-direction: row-reverse;
  font-weight: 700;
  gap: ${o => o.theme.spacing(1)};
  justify-content: flex-end;
  min-height: 0;
  padding: ${o => o.theme.spacing(1, 2)};
  width: 85px;

  ${fromMd} {
    ${cellText};
  }
`
